var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.66 33.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E2\\u05DC\\u05D9\\u05E0\\u05D5",
    "data-name": "\\u05E2\\u05DC\\u05D9\\u05E0\\u05D5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,4.23h9.21v28.2H0V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.2,24.3V4.23h9.16l.05,28.2H13.96v-8.13h7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.95,4.23h9.21v15.51h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.68,0h9.21v4.23h15.79l-12.17,29.14-8.41-3.43,7.43-17.58h-11.84V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.66,4.23v28.2h-27.87v-8.13h4.89V4.23h9.21v20.07h4.56V4.23h9.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/עלינוmdpi.718aa757b331bef5c857acef1668ebd6.svg";
export { ForwardRef as ReactComponent };